module.exports = __webpack_public_path__ + "img/download-on-the-app-store-pl.0cf79557.svg";